import { Outlet, Link as RouterLink, useLocation } from 'react-router-dom'
import { Box, Container, Flex, HStack, Button, ChakraProvider } from '@chakra-ui/react'
import { system } from '@/lib/chakra-theme'

/**
 * PublicLayout - Layout for public pages (landing, etc.)
 * ⚠️ This layout is completely independent of user session and agency branding.
 * It always uses the default Kopro branding with the standard theme.
 */
export function PublicLayout() {
  const location = useLocation()
  const isFounderPage = location.pathname === '/founder'

  return (
    <ChakraProvider value={system}>
      <Flex minH="100vh" direction="column" bg="gray.50">
      {/* Navigation Bar - Adaptive theme with blur */}
      <Box
        as="nav"
        position="sticky"
        top={0}
        bg="white/80"
        backdropFilter="blur(10px)"
        borderBottom="1px solid"
        borderColor="gray.200"
        zIndex={100}
      >
        <Container maxW="container.xl">
          <Flex h="70px" align="center" justify="space-between">
            {/* Logo - Always Kopro branding for public pages */}
            <RouterLink to="/">
              <img
                src="/assets/logo-inline-light.svg"
                alt="Kopro Logo"
                style={{ height: '50px', width: 'auto' }}
              />
            </RouterLink>

            {/* Navigation Links & Actions */}
            <HStack gap={6}>
              {/* Login Button */}
              <RouterLink to="/app/login">
                <Button
                  size="md"
                  variant="ghost"
                  color="gray.700"
                  _hover={{ bg: 'gray.100', color: 'gray.900' }}
                >
                  Connexion
                </Button>
              </RouterLink>

              {/* CTA Button - Hidden on /founder page */}
              {!isFounderPage && (
                <RouterLink to="/founder">
                  <Button
                    size="md"
                    colorPalette="brand"
                    bg="brand.600"
                    color="white"
                    _hover={{ bg: 'brand.700', transform: 'translateY(-2px)' }}
                    boxShadow="0 0 20px rgba(16, 185, 129, 0.3)"
                    transition="all 0.2s"
                  >
                    Rejoindre le Founders Program
                  </Button>
                </RouterLink>
              )}
            </HStack>
          </Flex>
        </Container>
      </Box>

      {/* Page Content */}
      <Box flex={1}>
        <Outlet />
      </Box>
    </Flex>
    </ChakraProvider>
  )
}
